import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class TimeZoneModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (TimeZoneModel._instance == null) TimeZoneModel._instance = new TimeZoneModel(authManager);
        return TimeZoneModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'core/time-zones', 'core/time-zones/codelist');

        this.entityName = 'core.TimeZone';
        this.privileges = {
            create: [["adminSystem"]],
            read: [["#everyone"]],
            update: [["adminSystem"]],
            delete: [["adminSystem"]],
        };

        this.label = 'Time Zone';
        this.setLabel = 'Time Zones';

        this.browser = {
            name: 'default-core-timezone-browser',
            moduleName: 'default-core-timezone-browser',
            moduleTitle: 'Time Zones',
            moduleStateSlotName: 'default-core-timezone-browser',
        };

        this.editor = {
            name: 'default-core-timezone-editor',
            moduleName: 'default-core-timezone-editor',
            moduleTitle: 'Time Zone',
            moduleStateSlotName: 'default-core-timezone-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'utcOffset',
                type: 'int',
                persistent: true,
                label: 'Comment',
                readOnly: true,
                filterable: true,
            },
            {
                name: 'usesDst',
                type: 'bool',
                persistent: true,
                label: 'Comment',
                readOnly: true,
                filterable: true,
            },
            {
                name: 'region',
                type: 'string',
                persistent: true,
                label: 'Region',
                readOnly: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
